import React, { useState, useEffect } from 'react';
import { QRCode } from "@progress/kendo-react-barcodes";
import PropTypes from 'prop-types';
import LoadingPanel from "../LoadingPanel";
import '../forms/Input.scss';
import './2FaDialog.scss';

import Dialog from '../dialogs/Dialog';
// import withStorage from './utils/withStorage';
import withMeta from '../utils/withMeta';


/**
 * Change password component
 * @module
 * @param {bool} isOpenChangePassword - Is dialog open? 
 * @param {func} handleConfirmChangePassword - Function on password change submit
 * @param {func} handleClose - Closes dialog function
 * @param {(string | number)} value - Value
 * 
 */
const MfaDialog = (props) => {
  const [state, setState] = useState({
    isLoading: false
  });
  const [mfaCode, setMfaCode] = useState(["", "", "", "", "", ""]);
  const [mfaIndex, setMfaIndex] = useState(0);
  const [mfaQR, setMfaQR] = useState("");
  const [isMfaEnabled, setMfaEnabled] = useState(true);
  const [invalidTry, setInvalidTry] = useState(false);

  const keyHandler = (event) => {
    if (((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105))) {
      setMfaCode((prevState) => {
        let newState = [...prevState];
        newState[mfaIndex] = event.key;
        return newState;
      });
      setMfaIndex((prevState) => {
        return prevState === 5 ? prevState : prevState + 1;
      });
      setInvalidTry(false);
    }
    else if (event.keyCode === 8) {
      resetMfa();
    }
  }

  useEffect(() => {
    if (props.isOpen) {
      const getQR = async () => {
        const res = await props.meta.get2faQR();
        setMfaQR(res?.QRUri);
        setMfaEnabled(res?.IsEnabled);
      };

      getQR();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isOpen]);

  useEffect(() => {
    if (props.isOpen) {
      if (mfaCode.find(x => x === "") !== undefined) {
        window.addEventListener("keyup", keyHandler);
        return () => {
          window.removeEventListener("keyup", keyHandler);
        };
      } else {
        handleConfirm();
      }
    }
  }, [mfaIndex, mfaCode, props.isOpen])

  const resetMfa = () => {
    setMfaCode(["", "", "", "", "", ""]);
    setMfaIndex(0);
    setInvalidTry(false);
  };

  const handleClose = () => {
    resetMfa();
    props.handleClose();
  };

  const handleConfirm = async () => {
    setState(prevState => ({ ...prevState, isLoading: true }))

    let res = await props.meta.enable2fa(mfaCode.join(''), !isMfaEnabled)
    if (res?.Code === "403.001") {
      setInvalidTry(true);
      new Promise(timer => setTimeout(timer, 3000)).then(() => {
        resetMfa();
      })
    } else {
      handleClose();
    }

    setState(prevState => ({ ...prevState, isLoading: false }))
  };

  return (
    <Dialog
      isOpen={props.isOpen}
      onClose={handleClose}
      onConfirm={handleConfirm}
      title={`${isMfaEnabled ? "Deaktivácia" : "Aktivácia"} dvojfaktorovej autentifikácie `}
      width={600}
      hideButtons={true}
    >
      <>
        <div className="k-content k-window-content k-dialog-content settings mfa">
          {!isMfaEnabled && <>
            <div className="code-label">Naskenujte kód Vašou autorizačnou aplikáciou</div>
            <QRCode
              value={mfaQR}
              errorCorrection="L"
            />
          </>}
          <div className="code-label">{`${(isMfaEnabled ? "Pre deaktivovanie" : "Pre aktiváciu")} dvojfaktorovej autentifikácie zadajte 6 miestny kód`}</div>
          <div className="code-field">
            <div className="code-container">
              <div id="codeInput" className="code-inputs">
                {mfaCode.map((item, i) => {
                  return <input key={`code-input-${i}`} id={`code-input-${i}`} className={`code-input${(i === mfaIndex && !item ? " current" : "")} ${invalidTry ? "invalid" : ""}`} type="text" inputMode="numeric" maxLength="1" value={item} readOnly/>
                })}
              </div>
            </div>
            {invalidTry && <div className='invalid-label'>Zadaný kód je neplatný</div>}
          </div>
        </div>
        <LoadingPanel isLoading={state.isLoading} />
      </>
    </Dialog>
  );

}

MfaDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
}

export default withMeta(MfaDialog);